import { FilterField, labelId } from "kontrolEdge/helpers/advancedFilters";
import { LogItem } from "./LogsData";
import { logAttributeValue, parseLogAttributes } from "./logAttributes";

/** Labels the expanded row's filter buttons put in a chip, so they must resolve here. */
export const CTXR_FIELD_LABEL = "CTX-R";
export const TIMESTAMP_FIELD_LABEL = "Timestamp";

/**
 * Search Log's `attribute: value` fields. Besides the columns, the CTX-R and
 * every attribute parsed out of a loaded message are fields, so the chip an
 * expanded row's filter button adds filters the table (CTX-1356): a key that
 * is not a field matches no row. The CTX-R is the page's selection, which every
 * loaded row belongs to.
 */
export function makeLogFields(ctxr: string, rows: LogItem[]): FilterField<LogItem>[] {
  const fields: FilterField<LogItem>[] = [
    {
      label: TIMESTAMP_FIELD_LABEL,
      key: "timestamp",
      accessor: (r) => r.timestamp,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Severity Level",
      key: "severitylevel",
      accessor: (r) => r.level,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Message",
      key: "message",
      accessor: (r) => r.message,
      type: "string",
      inFreeText: true,
    },
    // Out of free text from here on: the CTX-R would match every row, and
    // Message already holds every attribute value.
    {
      label: CTXR_FIELD_LABEL,
      key: "ctxr",
      accessor: () => ctxr,
      type: "string",
      inFreeText: false,
    },
  ];

  // Ensure keys are set
  for (const f of fields) f.key ||= labelId(f.label);

  // One field per attribute key seen; a key never shadows a column's field.
  const taken = new Set(fields.map((f) => f.key));
  for (const row of rows) {
    for (const { key, label } of parseLogAttributes(row.message)) {
      if (taken.has(key)) continue;
      taken.add(key);
      fields.push({
        label,
        key,
        accessor: (r) => logAttributeValue(r.message, key),
        type: "string",
        inFreeText: false,
      });
    }
  }
  return fields;
}
